<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7" r="3" stroke="#8F9BA0" stroke-width="2" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M17.0018 10.531C17.0018 10.7799 17.1851 10.9948 17.4339 10.9994C17.4559 10.9998 17.4779 11 17.5 11C19.433 11 21 9.433 21 7.5C21 5.567 19.433 4 17.5 4C17.4779 4 17.4559 4.0002 17.4339 4.00061C17.1851 4.00522 17.0018 4.2201 17.0018 4.46899V5.57692C17.0018 5.8249 17.252 6 17.5 6C18.3284 6 19 6.67157 19 7.5C19 8.32843 18.3284 9 17.5 9C17.252 9 17.0018 9.1751 17.0018 9.42308V10.531Z"
          fill="#8F9BA0" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.99823 10.531C6.99823 10.7799 6.81494 10.9948 6.56609 10.9994C6.54411 10.9998 6.52208 11 6.5 11C4.567 11 3 9.433 3 7.5C3 5.567 4.567 4 6.5 4C6.52208 4 6.54411 4.0002 6.56609 4.00061C6.81494 4.00522 6.99823 4.2201 6.99823 4.46899V5.57692C6.99823 5.8249 6.74798 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9C6.74798 9 6.99823 9.1751 6.99823 9.42308V10.531Z"
          fill="#8F9BA0" />
    <mask id="path-4-inside-1_5541_39105" fill="white">
      <path
        d="M5 18C5 14.6863 7.68629 12 11 12H13C16.3137 12 19 14.6863 19 18V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V18Z" />
    </mask>
    <path
      d="M11 14H13V10H11V14ZM17 18V20H21V18H17ZM18 19H6V23H18V19ZM7 20V18H3V20H7ZM6 19C6.55228 19 7 19.4477 7 20H3C3 21.6569 4.34315 23 6 23V19ZM17 20C17 19.4477 17.4477 19 18 19V23C19.6569 23 21 21.6569 21 20H17ZM13 14C15.2091 14 17 15.7909 17 18H21C21 13.5817 17.4183 10 13 10V14ZM11 10C6.58172 10 3 13.5817 3 18H7C7 15.7909 8.79086 14 11 14V10Z"
      fill="#8F9BA0" mask="url(#path-4-inside-1_5541_39105)" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M20.5 18.9991C20.2239 18.9991 20 19.2229 20 19.4991V20.4991C20 20.7752 20.2239 20.9991 20.5 20.9991H22H23C23.5523 20.9991 24 20.5514 24 19.9991V18.9991V17.9991C24 15.2312 22.1257 12.901 19.5771 12.2085C19.2787 12.1274 19 12.3637 19 12.6729V13.7375C19 13.9656 19.1558 14.1618 19.3702 14.2399C20.9045 14.7993 22 16.2712 22 17.9991V18.9991H20.5Z"
          fill="#8F9BA0" />
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.5 18.9991C3.77614 18.9991 4 19.2229 4 19.4991V20.4991C4 20.7752 3.77614 20.9991 3.5 20.9991H2H1C0.447715 20.9991 0 20.5514 0 19.9991V18.9991V17.9991C0 15.2312 1.87427 12.901 4.42289 12.2085C4.72126 12.1274 5 12.3637 5 12.6729V13.7375C5 13.9656 4.84418 14.1618 4.62984 14.2399C3.09552 14.7993 2 16.2712 2 17.9991V18.9991H3.5Z"
          fill="#8F9BA0" />
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
